

















import State from '@/classes/state';
import MapLegendItem from '@/models/map-legend-item.model';
import { getMarkerModifier } from '@/utility/map-utils';
import MarkerIcon from '@/models/marker-icon.model';

export default {
    name: 'Map',
    components: {},
    computed: {
        items(): Array<MapLegendItem> {
            const state: State = this.$store.state;
            const { markerIcons } = state;
            const keys = Object.keys(markerIcons).sort((keyA, keyB) => {
                const markerIconA: MarkerIcon = markerIcons[keyA];
                const markerIconB: MarkerIcon = markerIcons[keyB];
                return markerIconA.order - markerIconB.order;
            });
            
            return keys.map(mapIconId => {
                const markerIcon: MarkerIcon = markerIcons[mapIconId];

                return {
                    name: markerIcon.name,
                    modifier: getMarkerModifier(mapIconId),
                    icon: markerIcon.icon,
                };
            });
        },
    },
};
